import React from "react"

import globalStyles from "../../../../App.module.scss"

export default function JobControl() {
    return (
        <div className={globalStyles.article}>
            <h1>Job control</h1>
            <p>Interactive shells track background/suspended commands as "jobs", separate from full process
                management (see the <b>Process management</b> Linux page for <code>ps</code>/<code>kill</code>).</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '450px'}}>
                    <thead>
                    <tr>
                        <th>Command</th>
                        <th>Effect</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>cmd &amp;</code></td>
                        <td>Start <code>cmd</code> in the background</td>
                    </tr>
                    <tr>
                        <td><code>jobs</code></td>
                        <td>List background/suspended jobs for this shell</td>
                    </tr>
                    <tr>
                        <td><code>fg %1</code></td>
                        <td>Bring job 1 to the foreground</td>
                    </tr>
                    <tr>
                        <td><code>bg %1</code></td>
                        <td>Resume a suspended job in the background</td>
                    </tr>
                    <tr>
                        <td><code>Ctrl+Z</code></td>
                        <td>Suspend the foreground job</td>
                    </tr>
                    <tr>
                        <td><code>wait</code></td>
                        <td>Block until all background jobs finish</td>
                    </tr>
                    <tr>
                        <td><code>wait %1</code></td>
                        <td>Block until job 1 specifically finishes</td>
                    </tr>
                    <tr>
                        <td><code>disown %1</code></td>
                        <td>Detach job 1 from the shell — it survives even if the shell exits</td>
                    </tr>
                    <tr>
                        <td><code>kill %1</code></td>
                        <td>Send SIGTERM to job 1 (job spec, not a PID)</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Surviving a closed terminal</h3>
            <pre className={globalStyles.code}>
                <code>
                    nohup ./long-running.sh &amp;&nbsp;&nbsp;<span style={{opacity: 0.7}}># ignores SIGHUP, output -&gt; nohup.out</span><br/>
                    disown&nbsp;&nbsp;<span style={{opacity: 0.7}}># also detaches the most recent background job</span>
                </code>
            </pre>
            <p>For anything that needs to keep running after logout, prefer a proper <code>systemd</code>
                service (see the <b>systemd cheat sheet</b>) or a terminal multiplexer like <code>tmux</code>
                over <code>nohup</code>.</p>
        </div>
    )
}
